module.exports = __webpack_public_path__ + "static/media/directoriogeneral_noestassola_imgn_3.a01aa6f9.png";